// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","container":"_2Z5I","message":"_2BrR","error":"_1EcE","fadeEnter":"mqUf","fadeEnterActive":"_2Qhj","fadeExit":"_1agZ","fadeExitActive":"_2TeQ"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/InputMessage/InputMessage.scss
// module id = IaxQ
// module chunks = 0